#import "../fragments/lead-fragment.graphql"

query GetLead($id: ID, $number: Int) {
    lead(id: $id, number: $number) {
        ...Lead
    }
}
